import api from "./api";
import Table from "@/model/table";

class TableApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async index() {
    return await this.post('tables').then((response) => {
      if (!response?.data?.context.length) {
        return new Table();
      }
      return new Table(JSON.parse(response.data.context).data);
    });
  }
}

export default new TableApi();
